import { Subject, ReplaySubject } from "rxjs";
import { Injectable } from "@angular/core";
import { webSocket, WebSocketSubject } from "rxjs/webSocket";
import { tap } from "rxjs/operators";

import { ConnectionStatus } from "../../shared/enums";
import { ConfigService } from "./config.service";
import { RequestMessage } from "../../shared/enums/poker-types";

@Injectable()
export class AppWebSocketService {
  connectionStatus;
  private connectionSubject = new ReplaySubject<ConnectionStatus>(
    ConnectionStatus.close,
  );
  connectionStatus$ = this.connectionSubject.asObservable();

  private messageReceivedSubject = new Subject<any>();
  messageReceivedObservable = this.messageReceivedSubject.asObservable();

  private wsObservable: WebSocketSubject<any>;

  activity$ = new ReplaySubject<void>(1);

  constructor(private configService: ConfigService) {
    this.connectionStatus$
      .pipe(
        tap((status) => {
          console.log("STATUS", status);
        }),
      )
      .subscribe((status) => {
        console.log("ACTIVITY", status);
      });
  }

  initializeWebSocket() {
    if (
      this.connectionStatus !== undefined &&
      this.connectionStatus === ConnectionStatus.pending
    ) {
      return;
    }

    if (this.connectionStatus === ConnectionStatus.open) {
      this.wsObservable.unsubscribe();
      return; // this will trigger CLOSE
    }

    this.setConnectionStatus(ConnectionStatus.pending);

    this.wsObservable = webSocket(this.configService.config.wsUri);

    this.wsObservable.subscribe({
      next: (msg) => {
        // Called whenever there is a message from the server.
        if (msg.Settings && this.connectionStatus !== ConnectionStatus.open) {
          this.setConnectionStatus(ConnectionStatus.open);
        }

        this.messageReceivedSubject.next(msg);
      },
      error: (err) => {
        console.log("WS ERR ", err);
        this.setConnectionStatus(ConnectionStatus.error);
      },
      complete: () => {
        console.log("WS COMPLETE");
        this.setConnectionStatus(ConnectionStatus.close);
      },
    });
  }

  sendData(message) {
    console.log("SENDING", message);
    if (this.wsObservable) {
      console.log("SENDING 1", message);
      this.wsObservable.next(message);

      if (message.type !== RequestMessage.Ping) {
        this.activity$.next();
      }
    }
  }

  disconnect() {
    if (this.wsObservable) {
      this.wsObservable.complete();
    }
  }

  private setConnectionStatus(connectionStatus: ConnectionStatus) {
    this.connectionStatus = connectionStatus;
    this.connectionSubject.next(connectionStatus);
  }
}
